module.exports = __webpack_public_path__ + "static/img/photo07.2e5ee71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hakodate/photo07.jpg
// module id = 7tsV
// module chunks = 0